import { css, jsx } from '@emotion/react';
import { Typography, Colors } from '@zapier/design-system';

const styles = css(Object.assign(Object.assign({}, Typography.SmallPrint1), { color: Colors.GrayWarm9, textTransform: "lowercase", "&::before": {
  content: '"("'
}, "&::after": {
  content: '")"'
}, '&[data-state="disabled"]': {
  color: Colors.GrayWarm5
} }));
const LabelRequiredText = ({ children, isDisabled }) => {
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    jsx("span", { "aria-hidden": "true", css: styles, "data-state": isDisabled ? "disabled" : void 0, "data-zds": true }, children)
  );
};

export { LabelRequiredText };
//# sourceMappingURL=LabelRequiredText.es.js.map
